<template>
    <section class="featuredTiles smaller">
        <router-link class="tile"
            to="/post/welcome-to-creatillo">
            <img class="sectionImage"
                loading="lazy"
                src="/assets/icons/applications/creatillo.jpg"
                alt="Learn more about Creatillo"/>
            <div class="desc">
                <Heading
                    :h="4"
                    size="xs">
                    {{ siteContent.meetCreatillo }}
                </Heading>
                <div class="text">
                    {{ siteContent.learnAboutTheInitiative }}
                </div>
            </div>
        </router-link>
        <a class="tile"
            href="https://discord.com/invite/5mYNMAfuRR"
            target="_blank">
            <img class="sectionImage"
                loading="lazy"
                alt="Discord logo"
                src="/assets/icons/applications/discord.svg"/>
            <div class="desc">
                <Heading
                    :h="4"
                    size="xs">
                    {{ siteContent.joinUsOnDiscord }}
                </Heading>
                <div class="text">
                    {{ siteContent.discordPerks }}
                </div>
            </div>
        </a>
        <router-link class="tile"
            to="/recrop">
            <img class="sectionImage"
                loading="lazy"
                src="/assets/icons/applications/reCrop.jpg"
                alt="reCrop tool image"/>
            <div class="desc">
                <Heading
                    :h="4"
                    size="xs">
                    {{ siteContent.recropForInstagram }}
                </Heading>
                <div class="text">
                    {{ siteContent.cropImagesEasily }}
                </div>
            </div>
        </router-link>
    </section>
</template>

<script>
    export default {
        name: 'FeaturedTiles'
    }
</script>

<style lang="scss" scoped>
    @import '../../../scss/variables';

    .featuredTiles {
        width: 100%;
        border-radius: 0.75rem;
        backdrop-filter: blur(2rem);
        margin-bottom: 1rem;

        &:last-of-type {
            margin: 0;
        }
    }

    .smaller {
        font-size: 1rem;
    }

    .h4 {
        margin: 0;
    }

    .tile {
        display: flex;
        align-items: center;
        margin-bottom: 0.25rem;
        padding: 1rem;
        border-radius: 0.75rem;

        &:hover {
            background: var(--color-grey-150);
        }

        &:last-of-type {
            margin: 0;
        }
    }

    .desc {
        color: var(--color-black);
    }

    .text {
        color: var(--color-grey-500);
    }

    .sectionImage {
        border-radius: 1.25rem;
        width: 3.5rem;
        height: 3.5rem;
        object-fit: cover;
        display: flex;
        margin-right: 1.5rem;
    }
</style>